
import request from '@/util/request';

import { API_BASE_URL } from '../constant';
import { getToken } from "./auth";
import { getTimezone } from "./time";

export const getCurrentUser = () => requestWapper("/user/me", 'GET', null);

//auth
export const signup = (signupRequest) => requestWapper("/auth/signup", 'POST', signupRequest);
export const resendEmail = () => requestWapper("/auth/resendEmail", 'GET', null);
export const login = (loginRequest) => requestWapper("/auth/login", 'POST', loginRequest);
export const logout = () => requestWapper("/auth/logout", 'GET', null);
export const profileChangePwd = (option) => requestWapper("/auth/resetPwdMail", 'GET', option);
export const updateEmail = (currentUser) => requestWapper("/auth/updateEmail", 'PUT', currentUser);

//user
export const updateUser = (currentUser) => requestWapper("/user/update", 'PUT', currentUser);
export const updatePwd = (option) => requestWapper("/user/recoverPwd", 'PUT', option);
export const getHeadimg = () => requestWapper("/user/getHeadImg", 'GET', null);
export const getHeadimgList = () => requestWapper("/user/getHeadImgList", 'GET', null);
export const setHeadImg = (id) => requestWapper("/user/setHeadImg/" + id, 'POST', null);
export const addHeadImg = (data) => requestWapper("/user/addHeadImg", 'POST', data);
export const checkUsername = (username) => requestWapper("/user/front/checkUsername/" + username, 'GET', null);
export const checkAccount = (email) => requestWapper("/user/front/getEmail/" + email, 'GET', null);
export const checkChangePwdAccount = (email) => requestWapper("/user/front/existsChangePwdAccount/" + email, 'GET', null);
export const receiveNews = (checked) => requestWapper("/user/receiveNews/" + checked, 'POST', null);
export const receiveMessage = (type, checked) => requestWapper("/user/receiveMessage/" + type + '/' + checked, 'POST', null);
export const switchTranslate = (useTranslate) => requestWapper("/user/switchTranslate/" + useTranslate, 'POST', null);
export const getRandomName = () => requestWapper("/user/front/getRandomName", 'GET', null);
export const getUsername = (option) => requestWapper("/user/front/getUsername", 'POST', option);


//outerGame
// export const gamePublic= (option) => requestWapper( "/outerGame/front/list",'GET', option);
export const gameDetailPublic = (id) => requestWapper("/outerGame/front/detail/" + id, 'GET', null);



// tencent cloud cos
export const cosSts = () => requestWapper('/file/cosStsPublic', 'GET', null);
export const cosStsRegion = () => requestWapper('/file/cosStsRegion', 'GET', null);

//获取云游戏信息接口
export const getMatrixInfo = (topicUid) => requestWapper("/cloudGame/" + topicUid, 'GET', null);
export const checkFistPlay = () => requestWapper("/cloudGame/checkFistPlay", 'GET', null);
export const checkPlayOver2min = (gameId) => requestWapper("/cloudGame/checkPlayOver2min/" + gameId, 'GET', null);
export const getMatrixInfoByGameId = (gameId, isH5 = false) => requestWapper("/back/cloudgame/gameID/" + gameId + "?type=" + (isH5 ? "h5" : "pc"), 'GET', null);
// https://cloudgame-test.gameexp.com/v1/back/cloudgame/gameID/545007?type=pc
// https://cloudgame-test.gameexp.com/v1/back/cloudGame/gameId/545007?type=pc
export const getCloudGameList = (option) => requestWapper("/cloudGame/list", 'GET', option);

export const uploadDelayTime = (obj) => requestWapper("/cloudGame/reportDelay", 'POST', obj);
export const reportVisitUser = (obj) => requestWapper("/cloudGame/reportVisitUser", 'POST', obj);
export const reportVisitPage = (obj) => requestWapper("/cloudGame/reportVisitPage", 'POST', obj);

export const checkVisitPlay = (obj) => requestWapper("/cloudGame/checkVisitorPlay", 'GET', obj);

//个人主页
export const userInfo = (name) => requestWapper("/user/front/profile/userInfo/" + name, 'GET', null);
export const userPostList = (option) => requestWapper("/discussion/getPostByUserName", 'GET', option);
export const userPostCommentList = (option) => requestWapper("/discussion/getCommentByUserName", 'GET', option);
export const userGameCommentList = (option) => requestWapper("/gameComment/front/getCommentByUserName", 'GET', option);
export const userNewsCommentList = (option) => requestWapper("/comment/front/getCommentByUserName", 'GET', option);
export const userGameList = (option) => requestWapper("/outerGame/front/getListByUserName", 'GET', option);
export const followUser = (option) => requestWapper("/user/profile/follow", 'POST', option);
export const unfollowUser = (option) => requestWapper("/user/profile/unfollow", 'POST', option);
export const postByName = (option) => requestWapper("/user/front/getPostByName", 'GET', option);
export const myGames = (option) => requestWapper("/user/front/getMyGames", 'GET', option);
export const userContent = (name, option) => requestWapper("/user/front/profile/author/articles/" + `${name}`, 'GET', option);

//CookiesBanner
export const getCookiesBanner = (option) => requestWapper("/auth/getCookiesBanner", 'GET', option);
export const setCookiesBanner = (option) => requestWapper("/auth/setCookiesBanner", 'POST', option);
export const reportChannel = (option) => requestWapper("/user/front/reportChannel", 'POST', option);


//游戏包下载
export const getPackageLink = (obj) => requestWapper("/front/download", 'GET', obj);

// PWA
export const addMsgToken = (option) => requestWapper("/pushMsg/front/device/add", 'POST', option);
// 用户fingerId与openId 关联
export const addFingerUser = (option) => requestWapper("/fingerUser/front/add", 'POST', option);



//更新隐私协议
export const getPrivacy = () => requestWapper("/user/getPrivacy ", 'GET', null);
export const updatePrivacy = () => requestWapper("/user/updatePrivacy", 'POST', null);

//上报通道
export const gameDetailReportChannel = (option) => requestWapper("/report/front/report", 'POST', option);

//统计在线时长
export const collectTime = (option) => beaconRequestUrl("/user/front/collect", 'POST', option);

// 云游戏独立链接的相关接口
/**
 * 根据游戏id获取对应的SDK初始化参数
 * @param { string } gameId 
 * @returns 
 */
export const getSdkInfoByGameID = (gameId) => requestWapper("/back/cloudgame/getSec", 'GET', { 'sUID': gameId });
/**
 * 通过code拿到google的uid
 * @param { string } gameId 游戏id
 * @param { string } code google授权之后的code
 * @param { string } redirectUri 回调地址 
 * @returns 
 */
export const getThirdLoginUid = (params) => requestWapper("/back/auth/mcLogin", 'GET', params);
/**
 * 第三方登录之后的后台登录接口
 * @param {*} params 
 * @returns 
 */
export const mcSignUp = (params) => requestWapper("/auth/mcSignUp", 'POST', params);

// 获取指纹登录code
export const getSignUpCode = () => requestWapper("/back/auth/getSignUpCode", 'GET', null);

// 用code获取user_key
export const signUpWithCode = (params) => requestWapper("/back/auth/signUpWithCode", 'POST', params);

// twitter 1.0a获取request_token
export const getRequestToken = (params) => requestWapper("/back/auth/getOAuth1Token", 'GET', params);

export const getTwitterUser = (params) => requestWapper("/back/auth/oauth1", 'GET', params);

// 获得活动规则内容
export const getActivityDetails = (params) => requestWapper(`/back/activity/${params}`, 'GET', null);

// 获得用户在指定游戏的cdkeylist
export const getCdkeyList = (gameid, deviceid) =>
  requestWapper(`/back/cloudgame/gameBonusCode/${gameid}?sDeviceID=${deviceid}`, "GET", null);
// 获得活动列表
export const getActivityList = (gameid, deviceid) =>
  requestWapper(`/back/activity/all?sUID=${gameid}&sDeviceID=${deviceid}`, "GET", null);
// 参加活动
export const joinActivity = (iActivityID) => requestWapper(`/back/activity/join`, 'POST', { "iActivityID": iActivityID });
// hok活动列表
export const hokTaskList = (gameid) => requestWapper(`/back/hok/tasks?sUID=${gameid}`, 'GET', null);
// hok关卡奖励列表
export const hokRewardList = (gameid) => requestWapper(`/back/hok/challenges?sUID=${gameid}`, 'GET', null);
// 绑定openid和token
export const updateLink = (params) => requestWapper("/back/hok/updateLink", 'POST', params);
// 拉取公告信息
export const getNotification = (gameid) =>
  requestWapper(`/back/cloudgame/notification?sUID=${gameid}`, "GET", null);


const requestWapper = (pathInfo, method, data) => {
  let url = API_BASE_URL + "/v1" + pathInfo;
  if (method === 'GET' && data)
    url = url + "?" + new URLSearchParams(data);
  let headers = {
    'Content-Type': 'application/json', //设置跨域头部
    "Authorization": getToken(),
    // "T-Zone": getTimezone(),
  };
  return request({ url: url, method: method, data: data, headers: headers })
    .then(res => {
      if (res.code !== 0) {
        return Promise.reject(res);
      };
      return res;
    }
    ).catch(err => {
      // 若在登陆（包括主站登陆和云游戏登陆）页面之外遇到了401，直接跳转主站登陆页
      if (
        err.code === 401
        && !window.location.href.includes('login')
        && !window.location.href.includes('cloudGame')
      ) {
        window.location = '/login?redirect=' + encodeURIComponent(window.location.pathname);
      };

      if (err.code === 403 && !window.location.href.includes('403')) {
        // window.location ='/login?redirect='+window.location.href
        window.location = '/login?redirect=' + encodeURIComponent(window.location.pathname);
      };
      return err;
    });
};
export const signupWithToken = (req, token) => requestWapperWithToken("/auth/signupWithToken", 'POST', req, token);
export const recoverPwd = (option, token) => requestWapperWithToken("/auth/recoverPwd", 'PUT', option, token);
//用于讨论区临时调试
const testRequestWapper = (pathInfo, method, data) => {

  let url = pathInfo;
  if (method === 'GET' && data)
    url = url + "?" + new URLSearchParams(data);

  let headers = {
    'Content-Type': 'application/json', //设置跨域头部
    "Authorization": getToken(),
  };
  return request({ url: url, method: method, data: data, headers: headers })
    .then(res => {
      if (res.code !== 0) {
        return Promise.reject(res);
      }
      return res;
    }
    ).catch(err => {
      if (err.code === 403 && !window.location.href.includes('403')) {
        window.location = '/login';
      }
      console.log(err);
      return err;
    });
};
//
const requestWapperWithToken = (pathInfo, method, data, token) => {
  let url = API_BASE_URL + "/v1" + pathInfo;
  if (method === 'GET' && data)
    url = url + "?" + new URLSearchParams(data);
  let headers = {
    'Content-Type': 'application/json', //设置跨域头部
    "Authorization": token,
    // "T-Zone": getTimezone(),
  };
  return request({ url: url, method: method, data: data, headers: headers })
    .then(res => {
      if (res.code !== 0) {
        return Promise.reject(res);
      };
      return res;
    }
    ).catch(err => {
      if (err.code === 401 && !window.location.href.includes('login')) {
        window.location = '/login?redirect=' + window.location.href;
      };
      if (err.code === 403 && !window.location.href.includes('403')) {
        window.location = '/login?redirect=' + window.location.href;
      };
      console.log(err);
      return err;
    });
};

const beaconRequestUrl = (pathInfo, method, data) => {
  let url = API_BASE_URL + "/v1" + pathInfo;
  data['Authorization'] = getToken();
  let params = new Blob(
    [JSON.stringify(data)],
    { type: 'application/json' },
  );
  let res = navigator.sendBeacon(url, params); // 异步上报的方式
  console.log(res);
};

